import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import appReducer from "./app_reducer";
const rootReducers = combineReducers({
  routing: routerReducer,
  appReducer: appReducer,
});
export default rootReducers;
